import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiquorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.45703 24.3885V16.1465",
			stroke: "#6E2100",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.4564 16.1477L0.5 8.61328H14.4028L7.4564 16.1477Z",
			stroke: "#6E2100",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.49219 10.7658C2.49219 10.7658 4.33593 12.0714 7.45535 10.7658C10.5748 9.46023 12.4185 10.7658 12.4185 10.7658",
			stroke: "#6E2100",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.16797 24.3887H10.7357",
			stroke: "#6E2100",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4904 24.3888H22.6962V14.4725C22.6962 12.6587 22.1879 10.8847 21.2212 9.33997C20.2644 7.80518 19.7462 6.8285 19.7462 5.01466V0.5H18.4805",
			stroke: "#6E2100",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4909 24.3888H14.2852V14.4725C14.2852 12.6587 14.7934 10.8847 15.7601 9.33997C16.7169 7.80518 17.2351 6.8285 17.2351 5.01466V0.5H18.5009",
			stroke: "#6E2100",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3984 3.58008H20.5145",
			stroke: "#6E2100",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.6966 16.9646H20.4144C19.9659 16.3865 19.2782 16.0078 18.4909 16.0078C17.7036 16.0078 17.0159 16.3865 16.5674 16.9646H14.2852V19.9046H16.5674C17.0159 20.4826 17.7036 20.8613 18.4909 20.8613C19.2782 20.8613 19.9659 20.4826 20.4144 19.9046H22.6966V16.9646Z",
			stroke: "#6E2100",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.40622 8.48233C7.01344 8.48233 8.31635 7.17943 8.31635 5.57222C8.31635 3.96501 7.01344 2.66211 5.40622 2.66211C3.799 2.66211 2.49609 3.96501 2.49609 5.57222C2.49609 7.17943 3.799 8.48233 5.40622 8.48233Z",
			stroke: "#6E2100",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgLiquorIcon;
